module.exports = __webpack_public_path__ + "8361fe43d173506413dd0f310a7ffb4f.svg";